module.exports = __webpack_public_path__ + "static/img/11.1b2b01a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/zh/11.png
// module id = JaWn
// module chunks = 0